if (!globalThis.URLPattern) {
  await import(/* webpackChunkName: "urlpattern-polyfill" */ 'urlpattern-polyfill');
}

import { isRESTAPIError } from '@gonfalon/errors/RESTAPIError';
import { removeRecentProjectKey } from '@gonfalon/recent-projects/removeRecentProjectKey';

/**
 * Clears the recent project key from the recent projects list if the error is a 404 and the url includes 'selected-environments'.
 */
export function clearMissingRecentProjectKey(error: Error) {
  let clearedRecentProjectKey = false;

  if (isRESTAPIError(error)) {
    if (error.url.includes('selected-environments') && [404, 403].includes(error.status)) {
      const selectedEnvironments = new URLPattern({
        pathname: '/internal/profile/selected-environments/:projectKey',
      });
      const match = selectedEnvironments.exec(error.url);
      if (match && match.pathname.groups.projectKey) {
        clearedRecentProjectKey = removeRecentProjectKey(match.pathname.groups.projectKey);
      }
    }
  }

  return clearedRecentProjectKey;
}
